import React from 'react';
import Img from '../share/Img';
import PriceUnit from '../share/PriceUnit';

export default function ProductThumbSlider({ product }) {
  return (
    <div>
      <div className="os-product-wrap border cursor-pointer rounded-md border-light-gray-300 p-2 md:p-1 inline-block md:block overflow-hidden md:h-[85px]">
        <div className="flex items-center">
          <div className="os-product-img flex w-16">
            <Img image={product.media.thumb} width={64} height={64} />
          </div>
          <div className="os-product-info px-2 py-2 text-sm hidden md:block">
            <div className="mb-1 ">{product.title}</div>
            <div className="os-product-price ">
              <div>
                <div className="flex items-center">
                  <PriceUnit price={product.prices[0]?.sale} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
